var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lottie',{ref:"lottie",style:(_vm.style),attrs:{"options":_vm.options},on:{"animCreated":_vm.handleAnimation}})}
var staticRenderFns = []

export { render, staticRenderFns }